import React, { useState } from "react";

import { Collapse, List, ListItem, ListItemText } from "@mui/material";
import { ExpandLess as ExpandLessIcon, ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

import useCurrentBrand from "../../../../hooks/useCurrentBrand";
import { NavBarLink } from "../../../../models/nav.bar.link";
import useStyles from "./styles";

type Props = {
  group: string;
  navBarLinks: NavBarLink[];
  groupSelected?: string;
  navBarLinkSelected?: NavBarLink;
  redirectToNavBarLink: (navBarLink: NavBarLink, group: string) => void;
};

const ListSwiapleDrawer = (props: Props) => {
  const { navBarLinks, group, groupSelected, navBarLinkSelected, redirectToNavBarLink } = props;

  const { currentBrand } = useCurrentBrand();
  const classes = useStyles({ currentBrand });

  const { t: translate } = useTranslation();

  const [open, setOpen] = useState<boolean>();

  const handleClick = () => {
    setOpen(!open);
  };

  const renderListItems = () => {
    if (navBarLinks && navBarLinks.length > 0) {
      return navBarLinks.map((navBarLink) => {
        return (
          <React.Fragment key={navBarLink.path}>
            {renderListItem(
              translate(navBarLink.menuTitle),
              navBarLink.path === navBarLinkSelected?.path,
              navBarLink,
              "32px"
            )}
          </React.Fragment>
        );
      });
    }
  };

  const renderListCollapseItems = () => {
    return (
      <>
        <ListItem button onClick={handleClick}>
          <ListItemText primary={translate(group)} />
          {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </ListItem>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {renderListItems()}
          </List>
        </Collapse>
      </>
    );
  };

  const renderListItem = (
    title: string,
    isSelected: boolean,
    navBarLink: NavBarLink,
    paddingLeft?: string
  ) => {
    return (
      <ListItem
        className={isSelected ? classes.itemSelected : undefined}
        style={{ paddingLeft }}
        button
        onClick={() => redirectToNavBarLink(navBarLink, group)}
      >
        <ListItemText primary={title} />
      </ListItem>
    );
  };

  const renderContent = () => {
    if (navBarLinks && navBarLinks.length > 0) {
      if (navBarLinks.length > 1) return renderListCollapseItems();

      return renderListItem(translate(group), groupSelected === group, navBarLinks[0]);
    }

    return null;
  };

  return renderContent();
};

export default ListSwiapleDrawer;
